"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._validator = exports.initialErrorStatus = void 0;
const is_empty_1 = require("utils/is-empty");
exports.initialErrorStatus = {
    penalty: { status: false, message: 'Required' },
    time_in: { status: false, message: 'Required' },
    pit_name: { status: false, message: 'Required' },
    area_name: { status: false, message: 'Required' },
    seam_name: { status: false, message: 'Required' },
    brand_name: { status: false, message: 'Required' },
    dumptruck_no: { status: false, message: 'Required' },
    excavator_no: { status: false, message: 'Required' },
    contractor_name: { status: false, message: 'Required' },
    capacity_volume: { status: false, message: 'Required' },
};
const _validator = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    let validate = {
        isError: false,
        data: exports.initialErrorStatus
    };
    try {
        if ((0, is_empty_1.isEmpty)(arg.pit_name)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { pit_name: { status: true, message: 'Required' } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.penalty)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { penalty: { status: true, message: 'Required' } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.area_name)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { area_name: { status: true, message: 'Required' } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.seam_name)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { seam_name: { status: true, message: 'Required' } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.time_in)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { time_in: { status: true, message: 'Required' } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.brand_name)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { brand_name: { status: true, message: 'Required' } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.dumptruck_no)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { dumptruck_no: { status: true, message: 'Required' } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.excavator_no)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { excavator_no: { status: true, message: 'Required' } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.contractor_name)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { contractor_name: { status: true, message: 'Required' } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.capacity_volume)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { capacity_volume: { status: true, message: 'Required' } })
            };
        }
        return validate;
    }
    catch (error) {
        return {
            isError: false,
            data: exports.initialErrorStatus
        };
    }
});
exports._validator = _validator;
